import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { LoggedOutLayout } from 'containers';
import { BillingForm } from 'components';
import { initialSubscription, showStripeError } from 'redux/modules/billing';
import * as styles from './Billing.scss';
import queryString from 'query-string';
var Billing = (_dec = connect(function (state) {
  return {
    contract: state.contract,
    config: state.config,
    form: state.form
  };
}, {
  initialSubscription: initialSubscription,
  showStripeError: showStripeError
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(Billing, _Component);

  var _super = _createSuper(Billing);

  function Billing(props) {
    var _this2;

    _classCallCheck(this, Billing);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "getTotalDueTodayPartner", function () {
      var cp = _this2.props.contract.ContractPartners[0];
      var initialTeamMemberCost = parseInt(cp.initialTeamMembers) * parseInt(cp.initialTeamMembersMonthlyPrice);
      var initialClientCost = parseInt(cp.initialClients) * parseInt(cp.initialClientsMonthlyPrice);
      return initialTeamMemberCost + initialClientCost + parseInt(cp.monthlyFee);
    });

    _defineProperty(_assertThisInitialized(_this2), "getTotalDueToday", function () {
      var contractProducts = _this2.props.contract.ContractProducts;
      var numberOfMonths;

      if (_this2.state.payAdditionalMonths) {
        numberOfMonths = _this2.props.monthsPaidFor ? Math.floor(Math.max(1, parseInt(_this2.props.monthsPaidFor))) : 1;
      } else {
        numberOfMonths = 1;
      }

      return contractProducts.reduce(function (prev, curr) {
        var quantity = parseInt(curr.quantity);
        var setupFee = parseInt(curr.setupFee);
        var monthlyFee = parseInt(curr.monthlyFee);
        var adsFee = parseInt(curr.monthlyAdsBudget);
        var total = quantity * numberOfMonths * monthlyFee + setupFee + adsFee * quantity;
        return prev + total;
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this2), "handleSubmit", function (formData) {
      _this2.setState({
        checkoutInProgress: true
      });

      var _this = _assertThisInitialized(_this2);

      var stripePaymentObject;

      if (true) {
        //    if (this.props.contract.PaymentMethod.name.toLowerCase() === 'stripe credit card') {
        stripePaymentObject = Stripe.card;
      } else if (_this2.props.contract.PaymentMethod.name.toLowerCase() === 'stripe ach') {
        stripePaymentObject = Stripe.bankAccount;
      }

      stripePaymentObject.createToken({
        number: _this2.props.form.billing.values.cardNumber,
        exp_month: _this2.props.form.billing.values.expMonth,
        exp_year: _this2.props.form.billing.values.expYear,
        cvc: _this2.props.form.billing.values.cvc,
        name: _this2.props.form.billing.values.name,
        address_zip: _this2.props.form.billing.values.postcode
      }, function (status, response) {
        console.log('returned:', status, response);

        if (response.error) {
          _this.setState({
            checkoutInProgress: false
          });

          return _this2.props.showStripeError(response.error);
        }

        if (status === 200) {
          formData.paymentSourceId = response.id;
          formData.monthlyAmountInCents = _this2.props.contract.isPartner ? _this2.getTotalDueTodayPartner() * 100 : _this2.getTotalDueToday() * 100;

          if (!_this2.props.contract.isPartner) {
            var _this2$props$contract = _slicedToArray(_this2.props.contract.ContractProducts, 1),
                product = _this2$props$contract[0];

            formData.licenseFee = parseInt(parseFloat(product.monthlyFee) * 100);
            formData.adsFee = parseInt(parseFloat(product.monthlyAdsBudget) * 100);
            formData.customFee = parseInt(parseFloat(product.monthlyCustomFee) * 100);
            formData.setupFee = parseInt(parseFloat(product.setupFee) * 100);
          }

          _this2.props.initialSubscription(formData, _this2.props.params.contractUuid, _this2.state.affiliatePartnerSigning).then(function () {
            if (_this2.state.affiliatePartnerSigning) {
              var _this2$props$contract2 = _slicedToArray(_this2.props.contract.Organizations, 1),
                  org = _this2$props$contract2[0];

              if (org) {
                return _this2.context.router.push("/global/clients/".concat(org.id));
              }
            }

            _this2.context.router.push('/global/partner-user-setup');
          })["catch"](function (err) {
            return console.error(err);
          });
        } else {
          _this.setState({
            checkoutInProgress: false
          });

          console.log(status, response);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "componentDidMount", function () {
      Stripe.setPublishableKey(_this2.props.config.stripePublicKey);
    });

    var params = queryString.parse(window.location.search);
    _this2.state = {
      checkoutInProgress: false,
      affiliatePartnerSigning: params.affiliatesign && params.affiliatesign === 'true'
    };
    return _this2;
  }

  _createClass(Billing, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(LoggedOutLayout, {
        showNavBar: true
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Billing"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.billingHeader
      }, "Billing Information"), /*#__PURE__*/React.createElement(BillingForm, {
        getTotalDueToday: this.getTotalDueToday,
        getTotalDueTodayPartner: this.getTotalDueTodayPartner,
        onSubmit: this.handleSubmit,
        checkoutInProgress: this.state.checkoutInProgress
      })));
    }
  }]);

  return Billing;
}(Component), _defineProperty(_class2, "contextTypes", {
  router: PropTypes.object.isRequired
}), _temp)) || _class);
export { Billing as default };